package fr.frux.core.database

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class SpeciesCacheQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> select(mapper: (
    id: Long,
    etag: String?,
    payload: String,
    cached_at: Long,
  ) -> T): Query<T> = Query(1_865_118_557, arrayOf("species_cache"), driver, "speciesCache.sq", "select", "SELECT species_cache.id, species_cache.etag, species_cache.payload, species_cache.cached_at FROM species_cache WHERE id = 1") { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2)!!,
      cursor.getLong(3)!!
    )
  }

  public fun select(): Query<Species_cache> = select(::Species_cache)

  /**
   * @return The number of rows updated.
   */
  public fun put(
    etag: String?,
    payload: String,
    cached_at: Long,
  ): QueryResult<Long> {
    val result = driver.execute(-1_483_737_010, """
        |INSERT OR REPLACE INTO species_cache(id, etag, payload, cached_at)
        |VALUES (1, ?, ?, ?)
        """.trimMargin(), 3) {
          var parameterIndex = 0
          bindString(parameterIndex++, etag)
          bindString(parameterIndex++, payload)
          bindLong(parameterIndex++, cached_at)
        }
    notifyQueries(-1_483_737_010) { emit ->
      emit("species_cache")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun clear(): QueryResult<Long> {
    val result = driver.execute(45_590_476, """DELETE FROM species_cache""", 0)
    notifyQueries(45_590_476) { emit ->
      emit("species_cache")
    }
    return result
  }
}
